var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78571 0.214286C9.5 -0.0714286 9.07143 -0.0714286 8.78571 0.214286L3.42857 5.57143L1.21429 3.35714C0.928571 3.07143 0.5 3.07143 0.214286 3.35714C-0.0714286 3.64286 -0.0714286 4.07143 0.214286 4.35714L2.92857 7.07143C3.07143 7.21428 3.21429 7.28571 3.42857 7.28571C3.64286 7.28571 3.78571 7.21428 3.92857 7.07143L9.78571 1.21429C10.0714 0.928572 10.0714 0.5 9.78571 0.214286Z",
    fill: "#0A8F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValid);
export default __webpack_public_path__ + "static/media/IconValid.57c5b0979abf7bf77b1bb95ca5420e4a.svg";
export { ForwardRef as ReactComponent };